import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { Provider } from "react-redux";

import { createQueryClient } from "../config/queryClient";
import { store } from "../store/store";
import { theme } from "../theme";
import { ToastProvider } from '../context/ToastContext';
import { LoadingProvider } from '../context/LoadingContext';

interface AppProvidersProps {
    children: React.ReactNode;
}

const queryClient = createQueryClient();

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
    return (
        <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <ThemeProvider theme={theme}>
                        <CssBaseline />
                        <ToastProvider>
                            <LoadingProvider>
                                {children}
                            </LoadingProvider>
                        </ToastProvider>
                    </ThemeProvider>
                </LocalizationProvider>
            </Provider>
        </QueryClientProvider>
    );
};
